module.exports = __webpack_public_path__ + "static/img/1.8fac262.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/detect/1.jpg
// module id = lL/q
// module chunks = 13